/** Default search radius in km — used by the matching radius and the radius
 *  measure tool so both stay in sync. */
export const DEFAULT_RADIUS_KM = 30

/** Matching radius number-input bounds / arrow step (km). */
export const RADIUS_MIN_KM = 1
export const RADIUS_MAX_KM = 1500
export const RADIUS_STEP_KM = 10

/** 1 km below {@link RADIUS_STEP_KM}, else {@link RADIUS_STEP_KM} (incl. 10→9). */
export function getRadiusStep(current: number, direction: 1 | -1): number {
	if (current < RADIUS_STEP_KM) {
		return 1
	}

	if (direction === -1 && current === RADIUS_STEP_KM) {
		return 1
	}

	return RADIUS_STEP_KM
}
